<template>
    <div class="background-small">
        <div class="contact-container">
            <div class="contact-header">
                <h2 class="text-white">Contact Us</h2>
                <p class="text-gray">Get in touch with our support team</p>
            </div>

            <div class="contact-cards">
                <div class="contact-card">
                    <div class="card-icon">
                        <i class="fas fa-ticket-alt"></i>
                    </div>
                    <div class="card-content">
                        <h3>Support Ticket</h3>
                        <p>Create a ticket for detailed assistance</p>
                        <router-link to="/support" class="card-link">
                            Open Support Center
                            <i class="fas fa-arrow-right"></i>
                        </router-link>
                    </div>
                </div>

                <div class="contact-card">
                    <div class="card-icon">
                        <i class="fas fa-envelope"></i>
                    </div>
                    <div class="card-content">
                        <h3>Email Support</h3>
                        <p>Send us an email directly</p>
                        <a href="mailto:admin@steamanalyzer.com" class="card-link" target="_blank"
                            rel="noreferrer noopener">
                            admin@steamanalyzer.com
                            <i class="fas fa-arrow-right"></i>
                        </a>
                    </div>
                </div>

                <div class="contact-card">
                    <div class="card-icon">
                        <i class="fab fa-discord"></i>
                    </div>
                    <div class="card-content">
                        <h3>Discord Community</h3>
                        <p>Join our Discord for quick support</p>
                        <a href="https://discord.gg/nfCfpE3d6V" target="_blank" rel="noreferrer noopener"
                            class="card-link">
                            Join Discord Server
                            <i class="fas fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="faq-section">
                <h3 class="text-white">Frequently Asked Questions</h3>
                <div class="faq-link">
                    <router-link to="/faq" class="text-link">
                        Visit our FAQ page
                        <i class="fas fa-arrow-right"></i>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContactView'
};
</script>

<style scoped>
.contact-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
}

.contact-header {
    text-align: center;
    margin-bottom: 3rem;
}

.contact-header h2 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    background: linear-gradient(to right, #954ce9, #7d32d2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.text-gray {
    color: #999;
    font-size: 1.1rem;
}

.contact-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    margin-bottom: 3rem;
}

.contact-card {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 16px;
    padding: 2rem;
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.contact-card:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(149, 76, 233, 0.3);
}

.card-icon {
    width: 64px;
    height: 64px;
    background: linear-gradient(135deg, #954ce9 0%, #7d32d2 100%);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
}

.card-icon i {
    font-size: 1.8rem;
    color: white;
}

.card-content {
    flex: 1;
}

.card-content h3 {
    color: white;
    font-size: 1.25rem;
    margin-bottom: 0.75rem;
}

.card-content p {
    color: #999;
    margin-bottom: 1.5rem;
    font-size: 0.95rem;
}

.card-link {
    color: #954ce9;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 500;
    transition: all 0.3s ease;
}

.card-link:hover {
    color: #7d32d2;
}

.card-link i {
    font-size: 0.9rem;
    transition: transform 0.3s ease;
}

.card-link:hover i {
    transform: translateX(5px);
}

.faq-section {
    text-align: center;
    padding: 3rem 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.faq-section h3 {
    margin-bottom: 1rem;
    font-size: 1.5rem;
}

.text-link {
    color: #954ce9;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1.1rem;
    transition: all 0.3s ease;
}

.text-link:hover {
    color: #7d32d2;
}

.text-link i {
    font-size: 0.9rem;
    transition: transform 0.3s ease;
}

.text-link:hover i {
    transform: translateX(5px);
}

@media (max-width: 768px) {
    .contact-container {
        padding: 1.5rem;
    }

    .contact-header h2 {
        font-size: 2rem;
    }

    .contact-cards {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .contact-card {
        padding: 1.5rem;
    }

    .card-icon {
        width: 56px;
        height: 56px;
    }

    .card-icon i {
        font-size: 1.5rem;
    }
}
</style>